import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "team",
  class: "section-container"
}
const _hoisted_2 = { class: "section-content" }

import { vReveal } from '@/directives/reveal'

export default /*@__PURE__*/_defineComponent({
  __name: 'TeamSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "section-title" }, "Team", -1)),
      _createVNode(_component_a_card, { class: "authors-panel" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", {
            class: "lead-authors",
            "aria-label": "Core authors"
          }, [
            _createElementVNode("strong", null, "Core Authors:"),
            _createElementVNode("span", { class: "author-person" }, [
              _createElementVNode("span", { class: "author-name" }, "Le Cong"),
              _createElementVNode("span", { class: "author-affiliation" }, "Stanford")
            ]),
            _createElementVNode("span", {
              class: "author-separator",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", { class: "author-person" }, [
              _createElementVNode("span", { class: "author-name" }, "Mengdi Wang"),
              _createElementVNode("span", { class: "author-affiliation" }, "Princeton")
            ])
          ], -1),
          _createElementVNode("p", { class: "contributors-text" }, [
            _createElementVNode("strong", null, "Co-first Contributors:"),
            _createTextVNode(" Zaixi Zhang, Xiaotong Wang, Yin Di, Ruofan Jin, Michal Gerasimiuk, Yinkai Wang, Ravi K. Dinesh, David Smerkous, Alex Smerkous, Xuekun Wu, Shilong Liu, Peishan Li, Yi Zhu, Simran Serrao, Ning Zhao, Imran A. Mohammad, John B. Sunwoo, and Joseph C. Wu. ")
          ], -1),
          _createElementVNode("div", { class: "author-list-block" }, [
            _createElementVNode("div", { class: "author-list-title" }, [
              _createElementVNode("span", {
                class: "author-list-arrow",
                "aria-hidden": "true"
              }),
              _createElementVNode("span", null, "View full author listing & affiliations")
            ]),
            _createElementVNode("div", { class: "affiliations-text" }, [
              _createTextVNode(" Le Cong¹²*, Zaixi Zhang³*, Xiaotong Wang¹²*, Yin Di¹²*, Ruofan Jin³, Michal Gerasimiuk¹², Yinkai Wang¹², Ravi K. Dinesh¹², David Smerkous⁴, Alex Smerkous⁵, Xuekun Wu²⁶, Shilong Liu³, Peishan Li¹², Yi Zhu¹², Simran Serrao¹², Ning Zhao¹², Imran A. Mohammad²⁷, John B. Sunwoo²⁷, Joseph C. Wu²⁶, Mengdi Wang³**. "),
              _createElementVNode("br"),
              _createElementVNode("em", null, "(See paper for full institutional details.)")
            ])
          ], -1)
        ]))]),
        _: 1
      })
    ])), [
      [_unref(vReveal)]
    ])
  ]))
}
}

})